import { prop } from 'ramda';
import { useEffect } from 'react';
import * as urlUtils from 'js/utils/url.util';
import { useLocation } from 'react-router-dom';
import { usePrevious } from 'js/hooks/usePrevious';
import { useUserSelector } from 'js/store/hooks';
import { useRemoveQueryParams } from 'js/hooks/navigate';
import { savePromoCodeToStore, clearPromoCodeFromStore } from 'js/utils/promocode.util';

export const usePromoCode = () => {
    const location = useLocation();
    const removeQueryParams = useRemoveQueryParams();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const wasLoggedIn = usePrevious(isLoggedIn);

    useEffect(() => {
        if (!location) {
            return;
        }

        const promoCode = urlUtils.getURLParam(location.search, '__promocode__');

        if (promoCode) {
            savePromoCodeToStore(promoCode);
            removeQueryParams(['__promocode__']);
        }
    }, [location, removeQueryParams]);

    useEffect(() => {
        if (!isLoggedIn && wasLoggedIn) {
            clearPromoCodeFromStore();
        }
    }, [wasLoggedIn, isLoggedIn]);
};
